import * as Yup from 'yup';
import { IDictionary } from '@constants/languages/types';

const editTrialValidationSchema = (dictionary: IDictionary) =>
  Yup.object({
    appointmentTemplate: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().max(50, dictionary.validation.appointmentMax),
        type: Yup.string().required(dictionary.validation.type),
        duration: Yup.number().required(dictionary.validation.duration),
        protocolWindow: Yup.string().required(dictionary.validation.protocolWindow),
        date: Yup.string().required(dictionary.validation.appointmentDate),
        notificationsSettings: Yup.object().shape({
          types: Yup.object().shape(
            {
              email: Yup.string()
                .nullable()
                .when('sms', {
                  is: (sms: string) => !sms || sms.length === 0,
                  then: Yup.string().required(dictionary.validation.requireField),
                }),
              sms: Yup.string()
                .nullable()
                .when('email', {
                  is: (email: string) => !email || email.length === 0,
                  then: Yup.string().required(dictionary.validation.requireField),
                }),
            },
            ['sms', 'email'] as any,
          ),
          first: Yup.number().required(dictionary.validation.notification),
          second: Yup.number()
            .nullable()
            .lessThan(Yup.ref('first'), dictionary.validation.laterNotification),
        }),
      }),
    ),
  });

export default editTrialValidationSchema;
